/**
 * Маскировка текста в записях сессий PostHog — «белый список по переводам».
 *
 * Идея: текст интерфейса (кнопки, меню, заголовки, лейблы) — это ровно то, что
 * лежит в locales/*.json и выводится через t(). Всё, чего там нет — имена
 * клиентов, суммы, адреса, названия Работ и Объектов, комментарии — данные
 * тенанта и закрывается звёздочками. Размечать компоненты не нужно, а
 * забытое место «падает» в безопасную сторону (закрыто, а не открыто).
 *
 * Ограничение: строки с подстановкой («Работ: {{count}}») целиком не совпадут
 * со словарём и останутся закрытыми — так и задумано.
 */
import ru from '../locales/ru.json';
import en from '../locales/en.json';

const norm = (s) => s.replace(/\s+/g, ' ').trim();

function collect(node, out) {
  if (typeof node === 'string') {
    // Строки с подстановкой в DOM не совпадут дословно — в словарь не кладём.
    if (!node.includes('{{')) {
      const v = norm(node);
      if (v) out.add(v);
    }
  } else if (node && typeof node === 'object') {
    Object.values(node).forEach((child) => collect(child, out));
  }
  return out;
}

// Оба языка сразу: переключение языка не требует пересборки словаря.
const UI_TEXT = collect(en, collect(ru, new Set()));

const HAS_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

const stars = (text) => text.replace(/\S/g, '*');

// Сигнатура rrweb: (text, parentElement) → строка, уходящая в запись.
export function maskTextFn(text) {
  const v = norm(text);
  if (!v) return text;
  // Чистая пунктуация/символы («•», «/», «—») — не данные.
  if (!HAS_LETTER_OR_DIGIT.test(v)) return text;
  return UI_TEXT.has(v) ? text : stars(text);
}
